__turbopack_context__.v({
  "fieldset": "emob-cancellation-form-module-scss-module__NJWsuG__fieldset",
  "form": "emob-cancellation-form-module-scss-module__NJWsuG__form",
  "headline": "emob-cancellation-form-module-scss-module__NJWsuG__headline",
  "placeholder": "emob-cancellation-form-module-scss-module__NJWsuG__placeholder",
  "radio-group": "emob-cancellation-form-module-scss-module__NJWsuG__radio-group",
  "section": "emob-cancellation-form-module-scss-module__NJWsuG__section",
  "status-message": "emob-cancellation-form-module-scss-module__NJWsuG__status-message",
  "status-message-error": "emob-cancellation-form-module-scss-module__NJWsuG__status-message-error",
  "status-message-success": "emob-cancellation-form-module-scss-module__NJWsuG__status-message-success",
});
